import { executeOnSingleOrMultiple, getHslAnimationFromHsl, getRandom, getRangeMax, getRangeMin, getRangeValue, getStyleFromHsl, itemFromSingleOrMultiple, randomInRange, rangeColorToHsl, } from "tsparticles-engine";
import { AnimatableGradient } from "./Options/Classes/AnimatableGradient";
function updateColorOpacity(delta, value) {
    var _a, _b, _c;
    if (!value.enable) {
        return;
    }
    const decay = (_a = value.decay) !== null && _a !== void 0 ? _a : 1;
    switch (value.status) {
        case 0:
            if (value.value >= value.max) {
                value.status = 1;
            }
            else {
                value.value += ((_b = value.velocity) !== null && _b !== void 0 ? _b : 0) * delta.factor;
            }
            break;
        case 1:
            if (value.value <= value.min) {
                value.status = 0;
            }
            else {
                value.value -= ((_c = value.velocity) !== null && _c !== void 0 ? _c : 0) * delta.factor;
            }
            break;
    }
    if (value.velocity && decay !== 1) {
        value.velocity *= decay;
    }
}
function updateColorValue(delta, value, max, decrease) {
    var _a, _b;
    const colorValue = value;
    if (!colorValue || !colorValue.enable) {
        return;
    }
    const velocity = ((_a = value.velocity) !== null && _a !== void 0 ? _a : 0) * delta.factor, decay = (_b = value.decay) !== null && _b !== void 0 ? _b : 1;
    if (!decrease || colorValue.status === 0) {
        colorValue.value += velocity;
        if (decrease && colorValue.value > max) {
            colorValue.status = 1;
            colorValue.value -= colorValue.value % max;
        }
    }
    else {
        colorValue.value -= velocity;
        if (colorValue.value < 0) {
            colorValue.status = 0;
            colorValue.value += colorValue.value;
        }
    }
    if (colorValue.value > max) {
        colorValue.value %= max;
    }
    if (value.velocity && decay !== 1) {
        value.velocity *= decay;
    }
}
function updateAngle(delta, angle) {
    var _a, _b;
    const speed = ((_a = angle.velocity) !== null && _a !== void 0 ? _a : 0) * delta.factor, max = 2 * Math.PI, decay = (_b = angle.decay) !== null && _b !== void 0 ? _b : 1;
    if (!angle.enable) {
        return;
    }
    switch (angle.status) {
        case 0:
            angle.value += speed;
            if (angle.value > max) {
                angle.value -= max;
            }
            break;
        case 1:
        default:
            angle.value -= speed;
            if (angle.value < 0) {
                angle.value += max;
            }
            break;
    }
    if (angle.velocity && decay !== 1) {
        angle.velocity *= decay;
    }
}
function updateGradient(particle, delta) {
    var _a, _b, _c;
    const gradient = particle.gradient;
    if (!gradient) {
        return;
    }
    updateAngle(delta, gradient.angle);
    for (const color of gradient.colors) {
        if (((_a = particle.color) === null || _a === void 0 ? void 0 : _a.h) !== undefined) {
            updateColorValue(delta, color.value.h, 360, false);
        }
        if (((_b = particle.color) === null || _b === void 0 ? void 0 : _b.s) !== undefined) {
            updateColorValue(delta, color.value.s, 100, true);
        }
        if (((_c = particle.color) === null || _c === void 0 ? void 0 : _c.l) !== undefined) {
            updateColorValue(delta, color.value.l, 100, true);
        }
        if (color.opacity) {
            updateColorOpacity(delta, color.opacity);
        }
    }
}
export class GradientUpdater {
    getColorStyles(particle, context, radius, opacity) {
        var _a, _b;
        const gradient = particle.gradient;
        if (!gradient) {
            return {};
        }
        const gradientAngle = gradient.angle.value, fillGradient = gradient.type === "radial"
            ? context.createRadialGradient(0, 0, 0, 0, 0, radius)
            : context.createLinearGradient(Math.cos(gradientAngle) * -radius, Math.sin(gradientAngle) * -radius, Math.cos(gradientAngle) * radius, Math.sin(gradientAngle) * radius);
        for (const color of gradient.colors) {
            fillGradient.addColorStop(color.stop, getStyleFromHsl({
                h: color.value.h.value,
                s: color.value.s.value,
                l: color.value.l.value,
            }, (_b = (_a = color.opacity) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : opacity));
        }
        return { fill: fillGradient };
    }
    init(particle) {
        const gradient = itemFromSingleOrMultiple(particle.options.gradient);
        if (!gradient) {
            return;
        }
        particle.gradient = {
            angle: {
                value: gradient.angle.value,
                enable: gradient.angle.animation.enable,
                velocity: (getRangeValue(gradient.angle.animation.speed) / 360) * particle.container.retina.reduceFactor,
                decay: 1 - getRangeValue(gradient.angle.animation.decay),
            },
            type: gradient.type,
            colors: [],
        };
        let rotateDirection = gradient.angle.direction;
        if (rotateDirection === "random") {
            const index = Math.floor(getRandom() * 2);
            rotateDirection = index > 0 ? "counter-clockwise" : "clockwise";
        }
        switch (rotateDirection) {
            case "counter-clockwise":
            case "counterClockwise":
                particle.gradient.angle.status = 1;
                break;
            case "clockwise":
                particle.gradient.angle.status = 0;
                break;
        }
        const reduceDuplicates = particle.options.reduceDuplicates;
        for (const grColor of gradient.colors) {
            const grHslColor = rangeColorToHsl(grColor.value, particle.id, reduceDuplicates);
            if (!grHslColor) {
                continue;
            }
            const grHslAnimation = getHslAnimationFromHsl(grHslColor, grColor.value.animation, particle.container.retina.reduceFactor), addColor = {
                stop: grColor.stop,
                value: grHslAnimation,
                opacity: grColor.opacity
                    ? {
                        enable: grColor.opacity.animation.enable,
                        max: getRangeMax(grColor.opacity.value),
                        min: getRangeMin(grColor.opacity.value),
                        status: 0,
                        value: getRangeValue(grColor.opacity.value),
                        velocity: (getRangeValue(grColor.opacity.animation.speed) / 100) *
                            particle.container.retina.reduceFactor,
                        decay: 1 - getRangeValue(grColor.opacity.animation.decay),
                    }
                    : undefined,
            };
            if (grColor.opacity && addColor.opacity) {
                const opacityRange = grColor.opacity.value;
                addColor.opacity.min = getRangeMin(opacityRange);
                addColor.opacity.max = getRangeMax(opacityRange);
                const opacityAnimation = grColor.opacity.animation;
                switch (opacityAnimation.startValue) {
                    case "min":
                        addColor.opacity.value = addColor.opacity.min;
                        addColor.opacity.status = 0;
                        break;
                    case "random":
                        addColor.opacity.value = randomInRange(addColor.opacity);
                        addColor.opacity.status =
                            getRandom() >= 0.5 ? 0 : 1;
                        break;
                    case "max":
                    default:
                        addColor.opacity.value = addColor.opacity.max;
                        addColor.opacity.status = 1;
                        break;
                }
            }
            particle.gradient.colors.push(addColor);
        }
    }
    isEnabled(particle) {
        var _a, _b, _c;
        return (!particle.destroyed &&
            !particle.spawning &&
            (((_a = particle.gradient) === null || _a === void 0 ? void 0 : _a.angle.enable) ||
                ((_c = (_b = particle.gradient) === null || _b === void 0 ? void 0 : _b.colors.some((c) => c.value.h.enable || c.value.s.enable || c.value.l.enable)) !== null && _c !== void 0 ? _c : false)));
    }
    loadOptions(options, ...sources) {
        for (const source of sources) {
            if (!(source === null || source === void 0 ? void 0 : source.gradient)) {
                continue;
            }
            const gradientToLoad = source.gradient;
            if (!gradientToLoad) {
                continue;
            }
            options.gradient = executeOnSingleOrMultiple(gradientToLoad, (gradient) => {
                const tmp = new AnimatableGradient();
                tmp.load(gradient);
                return tmp;
            });
        }
    }
    update(particle, delta) {
        updateGradient(particle, delta);
    }
}
